// De bewerkmodus van de webshopwidget (golf 1C, Martijn 10-10-2026).
//
// "Test je widget" in het dashboard opent de webshop met ?bewerken=<teken>. Het teken is ondertekend door het dashboard, 30 minuten
// geldig en gebonden aan winkel en gebruiker; de api kijkt het bij elke aanvraag na (WebshopbewerkenController), en bij opslaan
// ook of de gebruiker het recht nog heeft. De widget haalt het na het laden meteen uit het adres (geldreview 11-10-2026: niet in
// de geschiedenis, niet in een gekopieerde of doorgestuurde link), bewaart het in sessionStorage (na een herlaadbeurt blijft de
// modus aan) en stuurt het alleen mee naar api/Webshopbewerken, in de kop X-Jimani-Bewerken. Een gast heeft nooit een teken: dan
// is er geen potlood en geen markering.

export const BEWERK_KOP = 'X-Jimani-Bewerken';
const OPSLAG = 'jimani-bewerken';

let teken = null;

function opslag() {
    try {
        return window.sessionStorage;
    } catch {
        return null;
    }
}

/** Het adres zonder ?bewerken=..., de rest blijft staan; null als er niets weg hoeft. */
export function adresZonderTeken(adres) {
    try {
        const url = new URL(adres);
        if (!url.searchParams.has('bewerken')) return null;
        url.searchParams.delete('bewerken');
        return url.pathname + (url.search || '') + (url.hash || '');
    } catch {
        return null;
    }
}

function wisUitAdres() {
    try {
        const nieuw = adresZonderTeken(window.location.href);
        if (nieuw) window.history.replaceState(window.history.state, '', nieuw);
    } catch { /* geen geschiedenis: niets */ }
}

/** Leest het teken uit het adres (en haalt het daar weg), anders uit wat in deze sessie is bewaard. */
export function startBewerkmodus(zoek = typeof window !== 'undefined' ? window.location.search : '', bewaarplek = opslag(),
    wis = typeof window !== 'undefined' ? wisUitAdres : () => {}) {
    let uitAdres = null;
    try {
        uitAdres = new URLSearchParams(zoek || '').get('bewerken');
    } catch {
        uitAdres = null;
    }

    if (uitAdres) {
        teken = uitAdres;
        try { bewaarplek?.setItem(OPSLAG, uitAdres); } catch { /* geen opslag: alleen deze pagina */ }
        wis();
    } else {
        try { teken = bewaarplek?.getItem(OPSLAG) || null; } catch { teken = null; }
    }

    return teken;
}

export const bewerkTeken = () => teken;

/** Het teken weggooien (verlopen of geweigerd): de widget is dan weer gewoon de webshop. */
export function stopBewerkmodus(bewaarplek = opslag()) {
    teken = null;
    try { bewaarplek?.removeItem(OPSLAG); } catch { /* niets */ }
}

/** De koppen voor een aanvraag naar api/Webshopbewerken. */
export const bewerkKoppen = () => (teken ? { [BEWERK_KOP]: teken } : {});

// Alleen voor de proeven.
export function _herstel() {
    teken = null;
}
